module.exports = __webpack_public_path__ + "media/images/logo-footer-026915076c90abac906ae02b252f161b.svg";